import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=2d894329&scoped=true"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"
import style0 from "./Setup.vue?vue&type=style&index=0&id=2d894329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d894329",
  null
  
)

export default component.exports